import { defineComponent as _defineComponent } from 'vue'
import GenericTHGCarTable from '@/components/thg/cars/GenericTHGCarTable.vue';
    import { computed, onMounted, ref, watch } from 'vue';
    import { THGCarPaginatedResponse } from '@/interfaces/thg/THGCarPaginatedResponse';
    import emitter from '@/utils/mitt';
    import { fetchTHGCars } from '@/api/thg/cars';
    import { useRoute } from 'vue-router/composables';
    import { THGUser } from '@/interfaces/thg/THGUser';
    import { getTHGUser } from '@/api/thg/users';
    import { generateDisplayName } from '@/utils/thg';
    import THGCarActions from '@/components/thg/cars/THGCarActions.vue';
    import { useTHGCarStore } from '@/storenew/thg/cars';
    import { storeToRefs } from 'pinia';
    import { useTHGGlobalStore } from '@/storenew/thg/global';
    import { Country } from '@/enums/Country';
    import THGCarYearSelect from '@/components/thg/cars/THGCarYearSelect.vue';

    interface Props {
        pageSize?: number;
    }

    
export default /*#__PURE__*/_defineComponent({
  __name: 'THGUserCarsList',
  props: {
    pageSize: { default: 20 }
  },
  setup(__props: any) {

const props = __props as { pageSize: number };

    

    const route = useRoute();
    const carStore = useTHGCarStore();
    const { filterParam } = storeToRefs(carStore);
    const { currentCountry } = useTHGGlobalStore();

    const data = ref<THGCarPaginatedResponse>();
    const currentPageNum = ref<number>(1);
    const currentUser = ref<THGUser>();

    const isPaginated = computed<boolean>(() => {
        return Boolean(data.value?.total_results && data.value?.total_results > props.pageSize);
    });

    async function fetchUserCars(pageNum: number) {
        // use the car store's filter (user and year) -> exactly the same cars as affected by the actions
        const response = await fetchTHGCars(
            filterParam.value,
            undefined,
            undefined,
            props.pageSize,
            pageNum,
        );
        const cars = await response.parsedBody;

        if (cars) {
            return cars;
        } else {
            throw new Error('cannot get user cars');
        }
    }

    async function fetchUser(userId: string) {
        const response = await getTHGUser(userId);
        const user = await response.parsedBody;

        if (user) {
            return user;
        } else {
            throw new Error('cannot get user');
        }
    }

    async function doDataFetching(pageNum: number) {
        emitter.emit('showLoader');
        data.value = (await fetchUserCars(pageNum)) as THGCarPaginatedResponse;
        emitter.emit('hideLoader');
    }

    async function onPageChange(pageNum: number) {
        currentPageNum.value = pageNum;
        await doDataFetching(currentPageNum.value);
    }

    async function onDataReloading() {
        await doDataFetching(currentPageNum.value);
    }

    onMounted(async () => {
        // reset the filter parameter, filter by user and all years by default
        carStore.resetFilterParams();
        filterParam.value.user_id = route.params.userId;
        filterParam.value.year = null;

        // watch the year only after setting the initial filter (no second request on mount)
        watch(
            () => filterParam.value.year,
            async () => {
                // year changed: start from first page, the current page may not exist anymore
                currentPageNum.value = 1;
                await doDataFetching(currentPageNum.value);
            },
        );

        await doDataFetching(1);

        // get the current user object either via route parameter or retrieve it
        if ('user' in route.params && route.params.user) {
            currentUser.value = route.params.user as unknown as THGUser;
        } else {
            currentUser.value = await fetchUser(route.params.userId);
        }
    });

return { __sfc: true,props, route, carStore, filterParam, currentCountry, data, currentPageNum, currentUser, isPaginated, fetchUserCars, fetchUser, doDataFetching, onPageChange, onDataReloading, GenericTHGCarTable, generateDisplayName, THGCarActions, Country, THGCarYearSelect }
}

})